/**
 * Created by Andrey Popov on 12/2/20.
 */

const ChatView = cc.Node.extend({
    ctor: function (chat) {
        this.chat = chat;

        this.messageViews = {};

        this._super();
        this.setAnchorPoint(0.5, 0.5);

        const container = this.container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);

        this.scroll = new cleverapps.UI.ScrollView(container);
        this.scroll.setAnchorPoint(0, 0);
        this.scroll.setAlignment(0, 0);
        this.addChild(this.scroll);

        this.onResize();

        this.chat.on("messagesUpdated", this.updateMessages.bind(this), this);
        this.chat.on("removeMessagesByType", this.removeMessagesByType.bind(this), this);
    },

    updateMessages: function () {
        this.chat.messages.forEach((message) => {
            if (!this.messageViews[message.id]) {
                const messageView = MessageViewFactory.create(message);
                this.container.addChild(messageView);
                this.messageViews[message.id] = messageView;
            } else if (message.tag !== this.messageViews[message.id].chatMessage.tag) {
                this.messageViews[message.id].updateContent(message);
            }
        });

        let height = cleverapps.UI.arrangeWithMargins(this.container.getChildren(), {
            margin: cleverapps.styles.ChatView.margin,
            direction: cleverapps.UI.VERTICAL
        });

        if (height < this.scroll.height) {
            height = this.scroll.height;
        }

        this.container.setContentSize2(cleverapps.resolution.getSceneSize().width, height);

        this.scroll.updateInnerContent();
        this.scroll.scrollToPercent(0);
    },

    removeMessagesByType: function (type) {
        Object.keys(this.messageViews).forEach((messageId) => {
            if (this.messageViews[messageId] && this.messageViews[messageId].chatMessage
                && this.messageViews[messageId].chatMessage.type === type) {
                this.messageViews[messageId].removeFromParent();
                this.messageViews[messageId] = undefined;
            }
        });
        this.updateMessages();
    },

    onResize: function () {
        const styles = cleverapps.styles.ChatView;

        const inputHeight = cleverapps.styles.ChatInput.height;
        const height = cleverapps.resolution.getSceneSize().height - cleverapps.styles.ChatHeader.height - inputHeight - styles.extraHeight;
        this.scroll.setContentSize2(cleverapps.resolution.getSceneSize().width, height);

        this.setContentSize2(this.scroll.getContentSize());
        this.setAlignment(styles);

        this.chat.messages.forEach((message) => {
            if (this.messageViews[message.id]) {
                this.messageViews[message.id].onResize();
            }
        });

        this.updateMessages();
    }
});

cleverapps.styles.ChatView = {
    x: { align: "center" },
    y: { align: "top", dy: -128 },

    margin: 4,

    scrollBarPosition: {
        x: 4,
        y: 14
    },

    extraHeight: 8
};